import { writeToClipboard } from 'base/clipboard';
import React from 'react';
import styles from './codeblock.css';
import { IconDuplicate } from './icons';

export function CodeBlock({
  code,
  children,
  onCopy,
}: {
  code: string;
  children?: React.ReactNode;
  onCopy?: () => void;
}) {
  function copy() {
    writeToClipboard({
      'text/plain': code,
    });
    onCopy?.();
  }
  return (
    <div className={styles.block}>
      <pre className={styles.pre}>
        <code className={styles.code}>
          {children != null ? children : code}
        </code>
      </pre>
      <button className={styles.copyButton} onClick={copy}>
        <IconDuplicate />
      </button>
    </div>
  );
}
